import { Typography } from '@mui/material';
import { Exception } from '@/redux/slices/slice_types';

import { titleCase } from '@/_utils/utils';

type ExceptionSeverityProps = {
  severity: Exception['severity'];
};

const exceptionSeverityColorDictionary: Record<Exception['severity'], string> = {
  warning: 'var(--warning-main)',
  critical: 'error',
  info: 'primary'
};

const ExceptionSeverity = ({ severity }: ExceptionSeverityProps) => {
  if (!severity || !Object.keys(exceptionSeverityColorDictionary).includes(severity.toLowerCase())) return <Typography>{severity}</Typography>;
  return <Typography color={exceptionSeverityColorDictionary[severity.toLowerCase()]}>{titleCase(severity)}</Typography>;
};

export default ExceptionSeverity;
